(() => {
  const BREAKPOINT = 990;

  const init = (header) => {
    if (!header || header.dataset.pc3106DrawerFit === 'true') return;
    header.dataset.pc3106DrawerFit = 'true';

    const container = header.querySelector('#Details-menu-drawer-container');
    const drawer = header.querySelector('#menu-drawer');
    if (!container || !drawer) return;

    const rootNav = drawer.querySelector('.menu-drawer__navigation');
    if (!rootNav) return;

    const openedNested = () => {
      const all = [...drawer.querySelectorAll('.menu-drawer__navigation details[open]')];
      return all.length ? all[all.length - 1] : null;
    };

    const activeContentHeight = () => {
      const nested = openedNested();
      if (nested) {
        const panel = nested.querySelector(':scope > .menu-drawer__submenu > .menu-drawer__inner-submenu');
        if (panel) {
          const subhead = panel.querySelector(':scope > .pc3101-drawer-subhead');
          const list = panel.querySelector(':scope > .pc3101-drawer-subhead + .menu-drawer__menu, :scope > .menu-drawer__menu');
          const styles = getComputedStyle(panel);
          const padding = (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
          const intrinsic = (subhead?.scrollHeight || 0) + (list?.scrollHeight || 0) + padding;
          if (intrinsic > 0) return intrinsic;
        }
      }
      return rootNav.scrollHeight;
    };

    const fit = () => {
      if (window.innerWidth >= BREAKPOINT || !container.open) return;
      const headerBottom = header.getBoundingClientRect().bottom;
      const max = Math.max(220, Math.min(window.innerHeight - headerBottom - 8, 560));
      const desired = Math.ceil(activeContentHeight() + 2);
      const next = Math.max(190, Math.min(desired, max));
      drawer.style.setProperty('--pc3106-drawer-height', `${next}px`);
    };

    const schedule = () => {
      requestAnimationFrame(() => requestAnimationFrame(fit));
    };

    container.addEventListener('toggle', schedule);
    drawer.querySelectorAll('details').forEach((details) => details.addEventListener('toggle', schedule));
    drawer.addEventListener('click', schedule);

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.type === 'attributes' && m.attributeName === 'open')) schedule();
    });
    observer.observe(drawer, { subtree: true, attributes: true, attributeFilter: ['open'] });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(schedule);
      ro.observe(rootNav);
    }
    window.addEventListener('resize', schedule, { passive: true });
  };

  const boot = () => document.querySelectorAll('.pc39-header-wrapper').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
